export default `
query product_page_hero($sku: String!, $path: String!) {
  productPageHero(sku: $sku, path: $path) {
    baseUrl
    menu {
      name
      url
    }
    product {
      name
      sku
      price
      media {
        file
        label
        mediaType
      }
      attributes {
        description
        leadTime
        urlKey
        image
      }
      bundleOptions {
        option_id
        title
        required
        type
        position
        sku
        product_links {
          id
          name
          sku
          option_id
          qty
          position
          is_default
          price
          can_change_quantity
        }
      }
    }
  }
}
`;
